import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTrashOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 12 13.3333"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M1.83333 2.5V11.5C1.83333 12.2364 2.43029 12.8333 3.16667 12.8333H8.83333C9.56971 12.8333 10.1667 12.2364 10.1667 11.5V2.5M1.83333 2.5H10.1667M1.83333 2.5H0.5M10.1667 2.5H11.5M7.33333 5.83333V9.5M4.66667 5.83333V9.5M4 2.5C4 1.39543 4.89543 0.5 6 0.5C7.10457 0.5 8 1.39543 8 2.5"
    />
  </svg>
);
export default SvgTrashOutline;
